'use strict';

import * as moduleList from '../actions/moduleList';

var defaultState = {
    modules: [],
    overlayMode: 'add',
    isOverlayVisible: false,
    isDeleteOverlayVisible: false,
    moduleToEdit: null,
    moduleToDelete: null,
    defaultForm: {
        id: 0,
        name: '',
        hex_colour: '#000000'
    }
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case moduleList.HIDE_ADMIN_MODULE_DELETE_OVERLAY:

            return Object.assign({}, state, {
                isDeleteOverlayVisible: false,
                moduleToDelete: null
            });
        
        case moduleList.SHOW_ADMIN_MODULE_DELETE_OVERLAY:

            return Object.assign({}, state, {
                isDeleteOverlayVisible: true,
                moduleToDelete: action.module
            });

        case moduleList.SET_ADMIN_MODULE_OVERLAY_VISIBILITY:

            return Object.assign({}, state, {
                isOverlayVisible: action.isVisible
            });

        case moduleList.SET_ADMIN_MODULE_OVERLAY_MODE:

            return Object.assign({}, state, {
                overlayMode: action.mode
            });

        case moduleList.SET_ADMIN_MODULE_TO_EDIT:

            return Object.assign({}, state, {
                moduleToEdit: action.module
            });

        case moduleList.SET_ADMIN_MODULES_LIST:

            return Object.assign({}, state, {
                modules: action.modules
            });

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/moduleList.js